import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AnnouncementForm from "./announcementComponents/AnnouncementForm";

import { useAppMeta } from "hooks";
import { useCreateAnnouncementMutation } from "store/services/announcementApi";

const AnnouncementCreateScreen = () => {
  
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Announcements",
      path: "/app/crm/announcement/list",
    },
    {
      title: "New Announcement",
    },
  ];

  // RTK Query
  const [createAnnouncement, { isLoading: creatingAnnouncement }] = useCreateAnnouncementMutation();

  // methods
  const handleAnnouncementCreate = (data) => {
    createAnnouncement(data)
      .unwrap()
      .then(() => {
        navigate(breadcrumbs[0].path);
        toast.success("Announcement created successfully");
      })
      .catch((err) =>
        toast.error(err?.data?.message ?? err?.message ?? "Couldn't create Announcement!")
      );
  };
  useAppMeta("New Announcement");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingAnnouncement}>
      <BreadcrumbLayout.Paper>
        <AnnouncementForm isBusy={creatingAnnouncement} onSubmit={handleAnnouncementCreate} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AnnouncementCreateScreen;
